var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[(_vm.meta.icon)?_c('i',{class:_vm.iconClass,staticStyle:{"font-size":"27px"},style:(_vm.iconStyle)}):_c('span',{domProps:{"textContent":_vm._s(_vm.text)}})])}
var staticRenderFns = []

export { render, staticRenderFns }